import { render } from "./App.vue?vue&type=template&id=c7b78a9a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c7b78a9a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__